module.exports = __webpack_public_path__ + "static/media/projects1.26f22b04.png";